export default __webpack_public_path__ + "static/media/no-program.ba400b27.svg";